import { ImportMode } from "@/graphql/generated/types";

/**
 * The two import options as the UI carries them.
 *
 * `dryRun` and `mode` are orthogonal in the backend contract (`ImportOptionsInput`
 * allows all four combinations), so they stay two independent values rather than
 * one four-way enum: collapsing them would invent a coupling the importer does not
 * have.
 */
export interface ImportRunOptions {
  dryRun: boolean;
  mode: ImportMode;
}

/**
 * Safe UI defaults: validate first, then let the operator explicitly promote
 * the reviewed result to a real import. The backend still defaults to a real
 * atomic import for API clients that do not use this UI.
 */
export const DEFAULT_IMPORT_OPTIONS: ImportRunOptions = {
  dryRun: true,
  mode: ImportMode.AllOrNothing,
};
